import { Configuration, ConfigurationParameters } from '@openapi/configuration';

/**
 * Custom API Configuration that extends the OpenAPI-generated Configuration.
 *
 * Fixes the issue where generated services declare `*\/*` as their only
 * accept header, which causes `isJsonMime('*\/*')` to return false and
 * the response to be parsed as a blob instead of JSON.
 *
 * This override ensures that `*\/*` is treated as `application/json`
 * so responses are correctly deserialized into typed objects.
 *
 * https://github.com/OpenAPITools/openapi-generator/issues/11494
 */
export class ApiConfiguration extends Configuration {
  constructor(params: ConfigurationParameters) {
    super(params);
  }

  override selectHeaderAccept(accepts: string[]): string | undefined {
    const selected = super.selectHeaderAccept(accepts);
    // When the only accept type is */*, the base isJsonMime check fails
    // and the generated code falls through to responseType = 'blob'.
    // Override to application/json so responses are parsed correctly.
    if (selected === '*/*') {
      return 'application/json';
    }
    return selected;
  }
}
